import React from 'react'

import {createLog} from '@util/logs'

import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import useNavigation from '@hook/useNavigation'
import {IGlobalNavigationStyles} from '@component/header/GlobalNavigation/GlobalNavigation'

import WizIcon from '@component/images/WizIcon'
import InvoiceCountDown from '@component/header/GlobalNavigation/InvoiceCountDown/InvoiceCountDown'
import NotificationDropdown from '@component/header/GlobalNavigation/NotificationDropdown/NotificationDropdown'

import IconInvoice from '@svg/gnb/ic_invoice.svg'
import IconInvoiceMobile from '@svg/gnb/ic_mo_invoice.svg'

interface IProps {
    className?: string
    navStyles?: IGlobalNavigationStyles
    notificationTrigger?: boolean
    setNotificationTrigger?: (notificationTrigger: boolean) => void
}

const NavigationMyOperations: React.FC<IProps> = ({
    className,
    navStyles,
    notificationTrigger,
    setNotificationTrigger,
}) => {
    const {goAccountInvoice} = useNavigation()

    const {data: me} = useQueryFetchMe(undefined, false)

    return (
        <>
            {/* User Notification Dropdown */}
            <NotificationDropdown
                className={'md:hidden'}
                onClickTrigger={notificationTrigger}
                setOnClickTrigger={() => setNotificationTrigger(!notificationTrigger)}
                iconColor={`${navStyles?.iconColor}`}
            />

            {/* User Invoice */}
            <div className={'relative h-[28px] md:h-[24px]'}>
                <WizIcon
                    className={`p-[6px] md:p-[0px] hover:bg-transparent01 dark:hover:bg-dark_transparent01 md:hover:bg-transparent relative ${navStyles?.iconColor} cursor-pointer`}
                    onClick={() => {
                        createLog('event', 'navigation_notification_click_invoice')
                        goAccountInvoice()
                    }}>
                    <IconInvoice className={`w-[16px] md:hidden`} />
                    <IconInvoiceMobile className={`w-[24px] hidden md:block`} />
                </WizIcon>
                {me?.pending_invoices > 0 && <InvoiceCountDown />}
            </div>
        </>
    )
}
export default NavigationMyOperations
